import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearSession } from '@/redux/slices/sessionStateSlice';

export type ColorMode = 'light' | 'dark' | 'system';

interface ColorModeState {
  mode: ColorMode;
}

/** The RoofVox brand is dark-first: a user with no saved preference (profile.theme_mode === null) sees Dark.
 *  Anyone who explicitly chose light / dark / system keeps it: that choice is stored on their profile. */
export const DEFAULT_COLOR_MODE: ColorMode = 'dark';

const initialState: ColorModeState = {
  mode: DEFAULT_COLOR_MODE,
};

const colorModeSlice = createSlice({
  name: 'colorMode',
  initialState,
  reducers: {
    setColorMode(state, action: PayloadAction<ColorMode>) {
      state.mode = action.payload;
    },
  },
  // Color mode is a per-USER preference but the slice is persisted to localStorage, so on logout
  // (manual or session-expiry) reset it to the default. Otherwise the next user to sign in on this
  // browser inherits the previous user's mode until their own profile loads (and, if they have no
  // saved preference, forever). ThemeSyncLoader then applies the signed-in user's actual choice.
  extraReducers: (builder) => {
    builder.addCase(clearSession, (state) => {
      state.mode = DEFAULT_COLOR_MODE;
    });
  },
});

export const { setColorMode } = colorModeSlice.actions;
export default colorModeSlice.reducer;
